"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _theme = _interopRequireDefault(require("../../Theme/lib/AirasiaClassic/theme"));
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize"];
var FlatbedBundled = function FlatbedBundled(props) {
  var fontsize = props.fontsize,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize
    }, theme),
    height = _parseStyles.sizeStyles.height;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    height: height,
    viewBox: "0 0 39 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,
    d: "M0.5 30H2.5C3.60457 30 4.5 30.8954 4.5 32V54L34.5 54V32C34.5 30.8954 35.3954 30 36.5 30C37.6046 30 38.5 30.8954 38.5 32V54V56C38.5 57.1046 37.6046 58 36.5 58L0.5 58V56V54V30Z",
    fill: _theme.default.colors.greyLight
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "6.5",
    y: "8",
    width: "26",
    height: "31",
    rx: "4",
    fill: _theme.default.colors.greyDarker
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "6.5",
    y: "52",
    width: "14",
    height: "26",
    rx: "4",
    transform: "rotate(-90 6.5 52)",
    fill: _theme.default.colors.primary
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "6.5",
    y: "9",
    width: "9",
    height: "26",
    rx: "2",
    transform: "rotate(-90 6.5 9)",
    fill: _theme.default.colors.primaryDark
  })), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(8.5, 12)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "10.8",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,
    d: "M0 10C0 4.48 4.47 0 9.99 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 9.99 20C4.47 20 0 15.52 0 10ZM10 13.45L14.23 16L13.11 11.18L16.84 7.95L11.92 7.53L10 3L8.08 7.54L3.16 7.96L6.89 11.19L5.77 16L10 13.45Z",
    fill: "#067E41",
    transform: "translate(1,1)"
  })));
};
FlatbedBundled.propTypes = _inline_svg2.default.propTypes;
FlatbedBundled.defaultProps = _inline_svg2.default.defaultProps;
var _default = FlatbedBundled;
exports.default = _default;